export const addMusic = (data) => (dispatch) => {
  dispatch({
    type: "ADD_MUSIC_FRONT",
    payload: data
  });
};
